import React from 'react';
import { MDBDataTable } from 'mdbreact';
import { round } from '../../util/util';
import '../../style/DataTable.css';

const PlayerStatisticsDetailDataTable = (props) => {
  const getPlayerStatisticsDetailData = () => {
    let rowData = [];

    props.playerStatistics.map((row) =>
      rowData.push({
        name: row.name,
        club: row.clubName,
        gamePinsTotalAverage:
          row.gamePinsTotalAverage !== -1
            ? round(row.gamePinsTotalAverage, 1)
            : '',
        gamePinsClassicAverage: round(row.gamePinsClassicAverage, 1),
        gamePinsSystemAverage: round(row.gamePinsSystemAverage, 1),
        gameMissedAverage: round(row.gameMissedAverage, 1),
        setAverage1: round(row.setAverages[0], 1),
        setAverage2: round(row.setAverages[1], 1),
        setAverage3: round(row.setAverages[2], 1),
        setAverage4: round(row.setAverages[3], 1),
        bestGameTotalPins: row.bestGameTotalPins,
        leastGameTotalPins: row.leastGameTotalPins,
        bestSetPins: row.bestSetPins,
        leastSetPins: row.leastSetPins,
        playedRounds: row.playedRounds,
      })
    );

    if (!rowData.length) {
      rowData = [{ name: '' }];
    }

    let columns = [
      {
        label: 'Nimi',
        field: 'name',
      },
      {
        label: 'Klubi',
        field: 'club',
      },
      {
        label: 'Keskmine tulemus',
        field: 'gamePinsTotalAverage',
      },
      {
        label: 'Klassika keskmine',
        field: 'gamePinsClassicAverage',
      },
      {
        label: 'Süsteemi keskmine',
        field: 'gamePinsSystemAverage',
      },
      {
        label: 'Keskm. mööda',
        field: 'gameMissedAverage',
      },
      {
        label: '1. seeria keskmine',
        field: 'setAverage1',
      },
      {
        label: '2. seeria keskmine',
        field: 'setAverage2',
      },
      {
        label: '3. seeria keskmine',
        field: 'setAverage3',
      },
      {
        label: '4. seeria keskmine',
        field: 'setAverage4',
      },
      {
        label: 'Parim tulemus',
        field: 'bestGameTotalPins',
      },
      {
        label: 'Väikseim tulemus',
        field: 'leastGameTotalPins',
      },
      {
        label: 'Suurim seeria',
        field: 'bestSetPins',
      },
      {
        label: 'Väikseim seeria',
        field: 'leastSetPins',
      },
      {
        label: 'Arv',
        field: 'playedRounds',
      },
    ];

    return {
      columns: columns,
      rows: rowData.sort((a, b) =>
        a.gamePinsTotalAverage < b.gamePinsTotalAverage ? 1 : -1
      ),
    };
  };
  const tableData = getPlayerStatisticsDetailData();

  return (
    <div>
      {tableData ? (
        <MDBDataTable
          responsive
          small
          striped
          hover
          noBottomColumns
          data={tableData}
          paginationLabel={['<', '>']}
          noRecordsFoundLabel={'Tulemusi ei leitud'}
          infoLabel={['Näitan', '-', 'kokku', 'kirjest']}
          entriesLabel={'Näita korraga'}
          entriesOptions={[10, 25, 50, 100, 200]}
          entries={props.entries ? props.entries : 10}
          searchLabel={'Otsi'}
          bordered={false}
          paging={!!props.paging}
          searching={!!props.searching}
          sortable={!!props.sortable}
          order={!!props.order ? props.order : []}
        />
      ) : (
        <div style={{ marginTop: '25px' }}>Info puudub</div>
      )}
    </div>
  );
};

export default PlayerStatisticsDetailDataTable;
